var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkFbIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home_web",
    transform: "translate(-1260.000000, -2281.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9-Copy",
    transform: "translate(-2.000000, 2166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(1262.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#202020",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "facebook-app-symbol",
    transform: "translate(8.000000, 6.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37076923,9.94480769 L3.37076923,5.40884615 L4.89269231,5.40884615 L5.12102564,3.64057692 L3.37076923,3.64057692 L3.37076923,2.51179487 C3.37076923,2 3.51230769,1.65121795 4.24705128,1.65121795 L5.18262821,1.65083333 L5.18262821,0.0692307692 C5.02083333,0.0482051282 4.46544872,0 3.81903846,0 C2.46923077,0 1.54512821,0.823910256 1.54512821,2.33666667 L1.54512821,3.64057692 L0.0185897436,3.64057692 L0.0185897436,5.40884615 L1.54512821,5.40884615 L1.54512821,9.94480769 L3.37076923,9.94480769 Z",
    id: "f_1_"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkFbIc);
export default __webpack_public_path__ + "static/media/dark_fb_ic.ddd76ff58bbff10834c914311b4b2d93.svg";
export { ForwardRef as ReactComponent };